import { render, staticRenderFns } from "./ConfigurazioniMagazzinoFornitoriListPage.vue?vue&type=template&id=6199d006"
import script from "./ConfigurazioniMagazzinoFornitoriListPage.vue?vue&type=script&lang=js"
export * from "./ConfigurazioniMagazzinoFornitoriListPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports